import { BankingCashCountDto } from './banking-cash-count.dto';

export class BankingMerchantLastCountsSearchResponseDto {
  posDeviceId: number;
  cash: BankingCashCountDto[];
  float: BankingCashCountDto[];
  card: BankingCashCountDto[];
}
